module.exports = __webpack_public_path__ + "static/webinar-1-57ab0002bcf36c4e217b965a4bb038ac.png";